import chunk from 'lodash/chunk';

export const splitCuratedLinksIntoList = (curatedLinks, chunkSize = 7) => {
  if (!Array.isArray(curatedLinks) || curatedLinks.length === 0) {
    return [];
  }

  return chunk(curatedLinks, chunkSize)
    .filter((set) => {
      return set.length === chunkSize;
    })
    .map((links) => {
      // Concatenate link section ID's into a single string and attach to the page.
      const curatedLinkIdHash = links.map(({ uuid, id }): string | number => uuid || id).join('-');
      return {
        curatedLinkIdHash,
        items: links,
      };
    });
};
